import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import request from '../../../request';
import ReactIcon from '../../Icons';
import {
  OFFERS_PLATFORMS,
  TRANSFORMATION_DATA_TYPE_JSON,
} from '../../../constants';

export default function OfferDevicePopup({ onHide, savedDevices = [] }) {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(savedDevices);

  const { getText } = Pollfish.ui;

  const onClick = useCallback(
    (value) => {
      const index = selected.findIndex((item) => item === value);
      if (index !== -1) {
        const array = [...selected];
        array.splice(index, 1);
        setSelected(array);
      } else {
        setSelected([...selected, value]);
      }
    },
    [selected],
  );

  const onSave = useCallback(() => {
    setLoading(true);
    request({
      url: '/v2/device/offerwall/offers/devices',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      transformData: true,
      transformationDataType: TRANSFORMATION_DATA_TYPE_JSON,
      data: { deviceTypes: selected },
    })
      .then(() => {
        setLoading(false);
        Pollfish.helper.setOffersSavedDevices(selected);
        Pollfish.offerwallPage.getOffers();
        onHide();
      })
      .catch(() => setLoading(false));
  }, [selected, onHide]);

  return (
    <div className="offerwall-offers-popup">
      <div className="offerwall-offers-popup-body" style={{ maxWidth: 444 }}>
        <button
          type="button"
          className="reset-button offerwall-offers-popup-actions-button-close"
          onClick={onHide}
          disabled={loading}
        >
          <ReactIcon type="close" size={18} />
        </button>
        <header className="text-md offerwall-offers-popup-body-header">
          {getText('offerwall.offers.deviceTypes.change')}
        </header>
        <div className="flex flex-align-items--center margin-lg-top margin-xl-btm">
          <div className="offerwall-offers-popup-device-wrapper">
            <button
              type="button"
              className={`reset-button offerwall-offers-popup-device ${
                includes(selected, OFFERS_PLATFORMS.ANDROID)
                  ? 'offerwall-offers-popup-device-selected'
                  : ''
              }`}
              onClick={() => onClick(OFFERS_PLATFORMS.ANDROID)}
            >
              <ReactIcon type="android" size={22} />
              <span className="margin-xs-top">Android</span>
            </button>
            <button
              type="button"
              className={`reset-button offerwall-offers-popup-device ${
                includes(selected, OFFERS_PLATFORMS.I_PHONE)
                  ? 'offerwall-offers-popup-device-selected'
                  : ''
              }`}
              onClick={() => onClick(OFFERS_PLATFORMS.I_PHONE)}
            >
              <ReactIcon type="iphone" size={22} />
              <span className="margin-xs-top">iPhone</span>
            </button>
            <button
              type="button"
              className={`reset-button offerwall-offers-popup-device ${
                includes(selected, OFFERS_PLATFORMS.I_PAD)
                  ? 'offerwall-offers-popup-device-selected'
                  : ''
              }`}
              onClick={() => onClick(OFFERS_PLATFORMS.I_PAD)}
            >
              <ReactIcon type="ipad" size={22} />
              <span className="margin-xs-top">iPad</span>
            </button>
          </div>
        </div>
        <div className="flex flex-justify--space-between">
          <button
            type="button"
            className="reset-button offerwall-offers-popup-device-btn offerwall-offers-popup-device-btn--cancel"
            onClick={onHide}
            disabled={loading}
          >
            <span className="text-sm">
              {getText('offerwall.offers.deviceTypes.cancel')}
            </span>
          </button>
          <button
            type="button"
            className="reset-button offerwall-offers-popup-device-btn offerwall-offers-popup-device-btn--save"
            onClick={onSave}
            disabled={loading}
          >
            <span className="text-sm">
              {getText('offerwall.offers.deviceTypes.save')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

OfferDevicePopup.propTypes = {
  onHide: PropTypes.func.isRequired,
  savedDevices: PropTypes.array,
};
